export interface BatchStatisticsReserveBestRequest {
  reserveDateFrom: string
  reserveDateTo: string
  isSearchBooks: boolean
  isSearchAV: boolean
  isSearchMagazine: boolean
  orderLimit: string
  isStatisticsBranch: boolean
  isStatisticsMaterialFormat: boolean
  isStatisticsBunruiType: boolean
  branch: string
  materialFormat: string
  bunruiDigits: string
  memo: string
  batchType: string
}

export function BatchStatisticsReserveBestRequestToJSON(
  value: BatchStatisticsReserveBestRequest
): any {
  return {
    reserve_date_from: value.reserveDateFrom,
    reserve_date_to: value.reserveDateTo,
    is_search_books: value.isSearchBooks,
    is_search_av: value.isSearchAV,
    is_search_magazine: value.isSearchMagazine,
    order_limit: value.orderLimit,
    is_statistics_branch: value.isStatisticsBranch,
    is_statistics_material_format: value.isStatisticsMaterialFormat,
    is_statistics_bunrui_type: value.isStatisticsBunruiType,
    branch: value.branch,
    material_format: value.materialFormat,
    bunrui_digits: value.bunruiDigits,
    memo: value.memo,
    batch_type: value.batchType
  }
}
